import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { RegisterPaymentFormComponent } from '../../component/register-payment-form/register-payment-form.component';
import { Invoice } from '../../model/invoice';
import { Observable } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class RegisterPaymentCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindowservice: ActionWindowService,
    private _injector: Injector,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command && command.context instanceof Invoice) {
      if (!command.context.attestedDate || !command.context.attestedDate.hasValue()) {
        this._messageService.showMessage('INVOICE.INFORMATION_TEXT.INVOICE_CERTIFIED_BEFORE_REGISTER_PAYMENT');
        return false;
      }
      return command.id === invoiceCommand.registerPayment;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionWindowservice.open(RegisterPaymentFormComponent, this._injector, null, command.context).pipe(
        map(res => {
          if (command.context instanceof Invoice) {
            command.context.remainingAmount = res.remainingAmount;
            command.context.unpaidInformationAmount = res.unpaidInformationAmount;
          }
        })
      );
    }
  }
}
